import { portraitImage } from "@/data/siteData";

export default function IdentityMasthead({ compact = false }) {
  return (
    <section
      className={`identity-masthead ${compact ? "identity-masthead-compact" : ""}`}
      data-testid="shared-identity-masthead"
      data-masthead-mode={compact ? "compact" : "full"}
      role="region"
      aria-label={compact ? "Ashwini Patil compact identity line" : "Ashwini Patil — Professional Identity and Biography Masthead"}
    >
      <div className="shell identity-masthead-inner">
        <div className="identity-masthead-lockup">
          <figure className="masthead-portrait-frame" data-testid="masthead-portrait">
            <img
              className="masthead-portrait"
              src={portraitImage}
              alt="Ashwini Patil — Data, Analytics & Decision Intelligence leader"
              width={270}
              height={256}
              loading="eager"
              decoding="async"
            />
          </figure>
          <div className="masthead-identity">
            <strong data-testid="masthead-name">Ashwini Patil</strong>
            <span data-testid="masthead-role">Data, Analytics &amp; Decision Intelligence leader</span>
          </div>
        </div>
        {!compact && <>
          <p className="masthead-bio" data-testid="masthead-bio">
            I work with organizations as they turn complex data and technology transformation into decisions people can understand, trust, and improve.
          </p>
          <div className="masthead-status-tag" data-testid="masthead-status-tag">
            <span className="masthead-status-dot" aria-hidden="true" />
            Open to conversation
          </div>
        </>}
      </div>
    </section>
  );
}
